export const labelsMapToJsonSerializableRecord = labels => {
  return Object.fromEntries(Array.from(labels.entries()).map(([key, values]) => [key, Array.from(values)]));
};